import Banner from 'pages/UniversalProductsPage/Banner/Banner';
export default Banner;
